/* AKKURANDO – Energie-Rechner der Akkunaut-Welt (Präfix akek, Handbuch Kap. 6 „Energie-Rechner“).
   Daten: snippets/akk-energie-daten.liquid (BLS 4.0, Datenblätter), als JSON in der Seite.
   Der Rechenkern läuft auch in Node: .github/scripts/energie-rechner-test.cjs prüft ihn gegen Handrechnungen. */
(function () {
  'use strict';
  var KJ_KCAL = 4.184, KJ_WH = 3.6;

  /* ---------- Rechenkern ---------- */
  function whOf(d) { return d.art === 'nahrung' ? d.kcal * KJ_KCAL / KJ_WH : d.wh; }
  // Energie, die von einem Stück „Ich habe …“ zählt
  function quelleWh(d, real, W) {
    if (!real) return whOf(d);
    if (d.art === 'nahrung') return whOf(d) * W.muskel.wert;
    return d.wh_real != null ? d.wh_real : d.wh;
  }
  // Energie, die eine Einheit „Das reicht für …“ braucht; null = nur rein rechnerisch sinnvoll
  function zielWh(z, real, D, W) {
    var base = z.ref ? whOf(D[z.ref]) : z.wh;
    if (!real) return base;
    if (z.art === 'laden') return base / W.laden.wert;
    if (z.art === 'primaer') return D[z.ref].wh_real;
    if (z.art === 'verbrauch') return base;
    return null;
  }
  function index(l) { var o = {}; l.forEach(function (x) { o[x.id] = x; }); return o; }
  function rechne(data, vonId, n, zuId, real) {
    var D = index(data.dinge), Z = index(data.ziele), W = data.wirkungsgrade, d = D[vonId], z = Z[zuId];
    var roh = whOf(d) * n, nutz = quelleWh(d, real, W) * n, je = zielWh(z, real, D, W), nur = je == null;
    if (nur) { nutz = roh; je = zielWh(z, false, D, W); }
    return { roh: roh, nutz: nutz, je: je, wert: nutz / je, nurRech: nur };
  }
  function nf(v, k) { return new Intl.NumberFormat('de-DE', { minimumFractionDigits: k, maximumFractionDigits: k }).format(v); }
  function zahl(v) {
    if (v < 20 && v >= 1 && Math.abs(v - Math.round(v)) < 0.005) return nf(Math.round(v), 0);
    return v >= 20 ? nf(Math.round(v), 0) : v >= 1 ? nf(v, 1) : nf(v, 2);
  }
  // „6,3 Handyladungen“, „22 % einer E-Bike-Akku-Ladung“, „12,7 Milliliter Benzin“
  function anzeige(z, v) {
    if (v >= 1 || (!z.anteil && !z.klein)) { var s = zahl(v); return { zahl: s, text: s === '1' ? z.einzahl : z.mehrzahl }; }
    if (z.klein) {
      var k = v * z.klein.faktor;
      if (k >= 1) { var t = zahl(k); return { zahl: t, text: t === '1' ? z.klein.einzahl : z.klein.mehrzahl }; }
      return { zahl: '< 1', text: z.klein.einzahl };
    }
    var p = v * 100;
    return { zahl: (p >= 10 ? nf(Math.round(p), 0) : p >= 1 ? nf(p, 1) : '< 1') + ' %', text: z.anteil };
  }
  function wh(v) { return v >= 1000 ? nf(v / 1000, 2) + ' kWh' : (v >= 100 ? nf(v, 0) : v >= 10 ? nf(v, 1) : nf(v, 2)) + ' Wh'; }
  // Einheiten in Wattstunden (ohne eval): inWh(500, 'mAh', 3.7) → 1,85 Wh. Einheiten: Wh, kWh, mWh, J, kJ, MJ, kcal, Ah, mAh (Ah/mAh brauchen die Spannung v)
  var FAKTOR = { Wh: 1, kWh: 1000, mWh: 0.001, J: 1 / 3600, kJ: 1 / KJ_WH, MJ: 1000 / KJ_WH, kcal: KJ_KCAL / KJ_WH };
  function inWh(menge, einheit, v) {
    if (einheit === 'Ah' || einheit === 'mAh') { if (!(v > 0)) throw new Error('Spannung fehlt'); return menge * v / (einheit === 'mAh' ? 1000 : 1); }
    if (!FAKTOR.hasOwnProperty(einheit)) throw new Error('Einheit unbekannt: ' + einheit);
    return menge * FAKTOR[einheit];
  }
  function ausWh(wert, einheit, v) { return wert / inWh(1, einheit, v); }
  /* Schnittstelle des Rechenkerns (Handbuch Kap. 6 „Energie-Rechner“), im Browser als window.AKEK, in Node per require.
     Lädt eine Seite dieses Skript ohne [data-akek], gibt es nur den Kern, keine Oberfläche. */
  var Calc = { whOf: whOf, quelleWh: quelleWh, zielWh: zielWh, rechne: rechne, anzeige: anzeige, zahl: zahl, wh: wh, inWh: inWh, ausWh: ausWh, version: 1 };
  if (typeof module !== 'undefined' && module.exports) module.exports = Calc;
  if (typeof document === 'undefined') return;
  window.AKEK = window.AKEK || Calc;

  /* ---------- Symbole (viewBox 40 × 40: Umriss | Füllfläche) ---------- */
  var IC = {
    phone: ['<rect x="11" y="3" width="18" height="34" rx="4"/><path d="M18 6h4"/>', 'M13.5 8.5h13v25h-13z'],
    aa: ['<rect x="13" y="7" width="14" height="30" rx="2.5"/><path d="M17.5 7V4.5h5V7M17 12.5h6"/>', 'M14.4 8.4h11.2v27.2H14.4z'],
    aaa: ['<rect x="15" y="7" width="10" height="30" rx="2"/><path d="M18.5 7V4.5h3V7"/>', 'M16.4 8.4h7.2v27.2h-7.2z'],
    '9v': ['<rect x="10" y="10" width="20" height="27" rx="2.5"/><path d="M13.5 10V6.5h5V10M23 10V8a2 2 0 0 1 4 0v2"/>', 'M11.4 11.4h17.2v24.2H11.4z'],
    coin: ['<circle cx="20" cy="20" r="14"/><circle cx="20" cy="20" r="10.5"/><path d="M20 16.5v7M16.5 20h7"/>', 'M20 6.6a13.4 13.4 0 1 1 0 26.8a13.4 13.4 0 1 1 0-26.8z'],
    bank: ['<rect x="9" y="6" width="22" height="31" rx="4"/><path d="M17 6V3.5h6V6"/>', 'M10.5 9h19v26.5h-19z'],
    ebike: ['<rect x="12" y="3" width="16" height="34" rx="7"/><circle cx="20" cy="9.5" r="1.6"/>', 'M13.5 13h13v17.5a6.5 6.5 0 0 1-13 0z'],
    led: ['<path d="M2 9q9 8 18 0t18 0M8 12.5V15M20 9v2.5M32 5.5V8"/><ellipse cx="8" cy="19.5" rx="3.2" ry="4.5"/><ellipse cx="20" cy="16" rx="3.2" ry="4.5"/><ellipse cx="32" cy="12.5" rx="3.2" ry="4.5"/>',
      'M4.8 19.5a3.2 4.5 0 1 0 6.4 0a3.2 4.5 0 1 0-6.4 0zM16.8 16a3.2 4.5 0 1 0 6.4 0a3.2 4.5 0 1 0-6.4 0zM28.8 12.5a3.2 4.5 0 1 0 6.4 0a3.2 4.5 0 1 0-6.4 0z'],
    pot: ['<path d="M8 16h24v14a5 5 0 0 1-5 5H13a5 5 0 0 1-5-5zM8 19H4.5M32 19h3.5M16 11c-1.4-1.6 1.4-3 0-4.6M24 11c-1.4-1.6 1.4-3 0-4.6"/>', 'M9 17h22v13a4 4 0 0 1-4 4H13a4 4 0 0 1-4-4z'],
    bike: ['<circle cx="9.5" cy="27" r="6.5"/><circle cx="30.5" cy="27" r="6.5"/><path d="M9.5 27H20l-4.5-11H27l3.5 11M15.5 16l-6 11M20 27l7-11M27 16l-1.2-4.5h3.2M15.5 16l-1-3M12 13h5"/>',
      'M4.5 27a5 5 0 1 0 10 0a5 5 0 1 0-10 0zM25.5 27a5 5 0 1 0 10 0a5 5 0 1 0-10 0z'],
    fuel: ['<path d="M11 9h12l6 6v19a3 3 0 0 1-3 3H11a3 3 0 0 1-3-3V12a3 3 0 0 1 3-3zM14 9V5.5h6V9M26 12l3-4h2.5"/>', 'M9.4 12a1.6 1.6 0 0 1 1.6-1.6h11.4l5.2 5.2V34a1.6 1.6 0 0 1-1.6 1.6H11A1.6 1.6 0 0 1 9.4 34z'],
    banana: ['<path d="M10 9c-1 12 5 21.5 16.5 22.8 3 .3 5-.9 5-2.4 0-1.1-1-1.6-2.5-1.6-9.5-.8-14.5-7.5-15.2-18.6M10 9l-.6-3.6 3.4-.5 1 4.5"/>',
      'M10.8 9.5c-1 11.6 4.7 20.6 15.8 21.8 2.6.3 4.1-.6 4.1-1.6 0-.5-.6-.8-1.7-.8-10.1-.8-15.4-8-16.1-19.4z']
  };
  var uid = 0;
  function icon(type, f, cls) {
    var i = IC[type], id = 'akek-c' + (++uid);
    return '<svg class="akek-ic ' + (cls || '') + '" viewBox="0 0 40 40" aria-hidden="true" focusable="false"><clipPath id="' + id + '"><path d="' + i[1] + '"/></clipPath>' +
      '<g clip-path="url(#' + id + ')"><rect class="akek-ic__f" width="40" height="40" style="--f:' + f.toFixed(3) + '"/></g><g class="akek-ic__o">' + i[0] + '</g></svg>';
  }

  /* ---------- Oberfläche ---------- */
  var root = document.querySelector('[data-akek]');
  if (!root || root.dataset.akekReady) return;
  var $ = function (s) { return root.querySelector(s); };
  var de = document.documentElement;
  // Bewegung aus bei „Bewegung reduzieren“ oder Footer-Schalter „Animationen aus“
  var ruhig = function () { return de.classList.contains('akk-motion-off') || (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches); };
  var S = { von: 'banane', n: 1, zu: 'handy', real: false, gruppe: 'essen' };
  var data, D, Z, mengeT;

  // Messereignisse (Handbuch Kap. 6, GA4-Namensschema): Shopify.analytics.publish, ein Custom Pixel leitet an GA4 weiter
  function track(name, p) {
    var d = { erlebnis_id: 'energie-rechner', erlebnis_art: 'rechner' };
    for (var k in p || {}) d[k] = p[k];
    (window.AKE_LOG = window.AKE_LOG || []).push([name, d]);
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, d); } catch (e) { /* Messung darf nie stören */ }
  }
  function zustand() { return { akek_von: S.von, akek_n: S.n, akek_zu: S.zu, akek_modus: S.real ? 'real' : 'rech' }; }
  function seite(u) { var m = /^https?:\/\/(?:www\.)?([^\/?#]+)/.exec(u || ''); return m ? m[1] : ''; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function leseUrl() {
    try {
      var q = new URLSearchParams(location.search), n = parseInt(q.get('n'), 10);
      if (D[q.get('von')]) S.von = q.get('von');
      if (Z[q.get('zu')]) S.zu = q.get('zu');
      if (n >= 1 && n <= 999) S.n = n;
      S.real = q.get('modus') === 'real';
    } catch (e) { /* Standardwerte */ }
    S.gruppe = D[S.von].gruppe === 'essen' ? 'essen' : 'technik';
  }
  function schreibeUrl() {
    try { history.replaceState(history.state, '', location.pathname + '?von=' + S.von + '&n=' + S.n + '&zu=' + S.zu + (S.real ? '&modus=real' : '') + location.hash); } catch (e) { /* egal */ }
  }

  function baue() {
    var h = { essen: '', technik: '' }, t = '', b = '';
    data.dinge.forEach(function (d) {
      h[d.gruppe === 'essen' ? 'essen' : 'technik'] += '<label class="akek-chip"><input type="radio" name="akek-von" value="' + d.id + '"><span>' + esc(d.name) + '</span></label>';
    });
    $('[data-akek-liste="essen"]').innerHTML = h.essen;
    $('[data-akek-liste="technik"]').innerHTML = h.technik;
    data.ziele.forEach(function (z) {
      t += '<button type="button" class="akek-tile" data-zu="' + z.id + '" aria-pressed="false">' + icon(z.icon, 1, 'akek-ic--s') + '<span class="akek-tile__z"></span><span class="akek-tile__t"></span></button>';
    });
    $('[data-akek-ziele]').innerHTML = t;
    data.beispiele.forEach(function (x) {
      var a = anzeige(Z[x.zu], rechne(data, x.von, x.n, x.zu, false).wert);
      b += '<li><button type="button" class="akek-ex" data-bsp="' + x.id + '"><span class="akek-ex__k">' + esc(x.titel) + '</span><span class="akek-ex__t">' +
        esc(x.n + ' ' + (x.n === 1 ? D[x.von].name : D[x.von].mehrzahl)) + ' ≈ <b>' + esc(a.zahl + ' ' + a.text) + '</b></span></button></li>';
    });
    $('[data-akek-bsp]').innerHTML = b;
    var s = '';
    for (var i = 0; i < 20; i++) s += '<i style="--i:' + i + '"></i>';
    $('[data-akek-seg]').innerHTML = s;
  }

  function render(quelle) {
    var d = D[S.von], z = Z[S.zu], W = data.wirkungsgrade, r = rechne(data, S.von, S.n, S.zu, S.real), a = anzeige(z, r.wert);
    root.querySelectorAll('[data-akek-gruppe]').forEach(function (b) {
      var g = b.getAttribute('data-akek-gruppe'), on = g === S.gruppe;
      b.setAttribute('aria-pressed', on); $('[data-akek-liste="' + g + '"]').hidden = !on;
    });
    root.querySelectorAll('input[name="akek-von"]').forEach(function (i) { i.checked = i.value === S.von; });
    root.querySelectorAll('input[name="akek-modus"]').forEach(function (i) { i.checked = (i.value === 'real') === S.real; });
    $('[data-akek-n]').value = S.n;
    $('[data-akek-minus]').disabled = S.n <= 1;
    $('[data-akek-portion]').textContent = (S.n === 1 ? d.name : d.mehrzahl) + ' · ' + d.portion;

    // Energie und Tank
    $('[data-akek-wh]').textContent = wh(r.roh);
    $('[data-akek-wh-sub]').textContent = d.art === 'nahrung'
      ? nf(Math.round(d.kcal * S.n), 0) + ' kcal · ' + nf(Math.round(d.kcal * S.n * KJ_KCAL), 0) + ' kJ'
      : nf(d.mah * S.n, 0) + ' mAh bei ' + new Intl.NumberFormat('de-DE', { maximumFractionDigits: 2 }).format(d.v) + ' V';
    var anteil = S.real ? quelleWh(d, true, W) / whOf(d) : 1, lit = Math.max(1, Math.round(anteil * 20));
    root.querySelectorAll('[data-akek-seg] i').forEach(function (el, i) { el.className = i < lit ? 'on' : ''; });
    var verlust = d.art === 'nahrung' ? 'Rest wird im Körper zu Wärme' : 'im Gerät liefert die Zelle weniger';
    $('[data-akek-tank]').textContent = S.real && anteil < 1 ? 'Davon nutzbar: ' + wh(r.nutz) + ' (' + nf(Math.round(anteil * 100), 0) + ' %, ' + verlust + ')'
      : S.real ? 'Davon nutzbar: alles (Ladeverluste zählen beim Ziel)' : 'Rein rechnerisch zählt alles';
    root.classList.toggle('is-real', S.real);
    root.classList.toggle('is-nur', r.nurRech && S.real);

    // Ergebnis
    $('[data-akek-zahl]').textContent = a.zahl;
    $('[data-akek-text]').textContent = a.text;
    $('[data-akek-modus]').textContent = r.nurRech && S.real ? 'nur rein rechnerisch möglich' : S.real ? 'realistisch' : 'rein rechnerisch';
    $('[data-akek-je]').textContent = (z.beschreibung ? z.beschreibung + ': ' : z.art === 'laden' ? 'Je Ladung: ' : 'Je Stück: ') + wh(r.je) +
      (S.real && z.art === 'laden' && !r.nurRech ? ' inklusive Ladeverlust' : '') + (S.real && z.art === 'primaer' ? ' (was die Zelle im Gerät liefert)' : '');
    $('[data-akek-formel]').textContent = wh(r.nutz) + (S.real && r.nutz !== r.roh ? ' nutzbar' : '') + ' ÷ ' + wh(r.je) + ' = ' + nf(r.wert, r.wert < 1 ? 3 : 2);
    $('[data-akek-peek] span').textContent = 'Reicht für ≈ ' + a.zahl + ' ' + a.text;

    // Symbolreihe: ab 25 Stück steht ein Symbol für 10 (100 …)
    var sk = 1;
    while (r.wert / sk > 24) sk *= 10;
    var cnt = r.wert / sk, full = Math.floor(cnt), rest = cnt - full, out = '', box = $('[data-akek-icons]');
    if (!full) out = icon(z.icon, Math.max(rest, 0.02));
    else { for (var i = 0; i < full; i++) out += icon(z.icon, 1); if (rest > 0.02) out += icon(z.icon, rest); }
    box.innerHTML = out;
    box.classList.toggle('is-viele', Math.ceil(cnt) > 9);
    box.querySelectorAll('.akek-ic').forEach(function (el, i) { el.style.setProperty('--d', Math.min(i * 22, 330) + 'ms'); });
    box.classList.remove('is-go');
    if (!ruhig()) { void box.offsetWidth; box.classList.add('is-go'); }
    $('[data-akek-skala]').textContent = sk > 1 ? '1 Symbol = ' + nf(sk, 0) + ' ' + z.mehrzahl : '';

    // höchstens ein dezenter Produktlink, nur mit Batterie- oder Akkubezug (Ziel vor Auswahl)
    var link = (z.ref && D[z.ref].link) || d.link, el = $('[data-akek-link]');
    el.hidden = !link;
    if (link) { el.href = link.href; el.querySelector('span').textContent = link.label; }

    root.querySelectorAll('[data-zu]').forEach(function (b) {
      var zz = Z[b.getAttribute('data-zu')], rr = rechne(data, S.von, S.n, zz.id, S.real), aa = anzeige(zz, rr.wert), nur = rr.nurRech && S.real;
      b.setAttribute('aria-pressed', zz.id === S.zu);
      b.classList.toggle('is-rech', nur);
      b.querySelector('.akek-tile__z').textContent = aa.zahl;
      b.querySelector('.akek-tile__t').textContent = aa.text + (nur ? ' · nur rechnerisch' : '');
    });
    rechenweg(d, z, r);
    $('[data-akek-live]').textContent = S.n + ' × ' + d.name + ': ' + (r.nurRech && S.real ? 'nur rein rechnerisch' : S.real ? 'realistisch' : 'rein rechnerisch') + ' etwa ' + a.zahl + ' ' + a.text + '.';
    schreibeUrl();
    if (quelle === 'menge') { clearTimeout(mengeT); mengeT = setTimeout(function () { track('akek_menge', zustand()); }, 600); }
    else if (quelle) track('akek_' + quelle, zustand());
  }

  function rechenweg(d, z, r) {
    var W = data.wirkungsgrade, L = [], q = {}, e1 = whOf(d), echt = S.real && !r.nurRech;
    (d.q || []).concat((z.ref ? D[z.ref].q : z.q) || []).forEach(function (k) { q[k] = 1; });
    q['wp-food-energy'] = 1;
    if (d.art === 'nahrung') {
      L.push(['Brennwert', d.rechnung]);
      L.push(['In Wattstunden', nf(d.kcal, 1) + ' kcal × 4,184 kJ/kcal ÷ 3,6 kJ/Wh = ' + wh(e1)]);
    } else L.push(['Energie', (d.rechnung ? d.rechnung + '. ' : '') + (d.bed || '')]);
    if (S.n > 1) L.push(['Menge', S.n + ' × ' + wh(e1) + ' = ' + wh(r.roh)]);
    if (echt && d.art === 'nahrung') { L.push(['Muskel', wh(r.roh) + ' × ' + nf(W.muskel.wert * 100, 0) + ' % = ' + wh(r.nutz)]); q['wp-human-power'] = q['wp-bicycle-performance'] = 1; }
    if (echt && d.art !== 'nahrung' && r.nutz !== r.roh) L.push(['Unter Last', 'Im Gerät liefert die Zelle ' + wh(r.nutz) + ' statt ' + wh(r.roh)]);
    var zt = z.ref ? (D[z.ref].rechnung || D[z.ref].bed || '') : (z.rechnung || '');
    L.push(['Je ' + z.einzahl, zt + (echt && z.art === 'laden' ? '; ÷ ' + nf(W.laden.wert * 100, 0) + ' % Ladewirkungsgrad = ' + wh(r.je) : '') + (echt && z.art === 'primaer' ? '; im Gerät: ' + wh(r.je) : '')]);
    if (S.real && z.art === 'laden') q['wp-li-ion'] = 1;
    L.push(['Ergebnis', wh(r.nutz) + ' ÷ ' + wh(r.je) + ' = ' + nf(r.wert, r.wert < 1 ? 3 : 2)]);
    var u = [d, z.ref ? D[z.ref] : z].filter(function (x) { return x.unsicher; }).map(function (x) { return x.unsicher_text; });
    if (S.real && z.art === 'laden') u.push(W.laden.unsicher_text);
    $('[data-akek-weg]').innerHTML = L.map(function (l) { return '<li><b>' + esc(l[0]) + '</b><span>' + esc(l[1]) + '</span></li>'; }).join('') +
      (d.gegenprobe ? '<li class="akek-weg__g"><b>Gegenprobe</b><span>' + esc(d.gegenprobe) + '</span></li>' : '');
    var un = $('[data-akek-unsicher]');
    un.innerHTML = u.map(function (t) { return '<li><b>Richtwert:</b> ' + esc(t) + '</li>'; }).join('');
    un.hidden = !u.length;
    $('[data-akek-quellen]').innerHTML = Object.keys(q).map(function (k) {
      var s = data.quellen[k];
      // Quellen-Link nach Regel „Niemand wird weggeschickt“: klein, „Titel (website)“, neuer Tab, data-akan-quelle
      return s ? '<li><a href="' + esc(s.url) + '" target="_blank" rel="noopener" data-akan-quelle>' + esc(s.titel) + ' (' + esc(seite(s.url)) + ')</a> <span>abgerufen ' + s.abgerufen.split('-').reverse().join('.') + '</span></li>' : '';
    }).join('');
  }

  function setN(n) { n = Math.max(1, Math.min(999, n | 0 || 1)); if (n !== S.n) { S.n = n; render('menge'); } else $('[data-akek-n]').value = S.n; }

  function binde() {
    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.name === 'akek-von') { S.von = t.value; render('quelle'); }
      else if (t.name === 'akek-modus') { S.real = t.value === 'real'; render('modus'); }
      else if (t.hasAttribute('data-akek-n')) setN(parseInt(t.value, 10));
    });
    root.addEventListener('click', function (e) {
      var b = e.target.closest('button,a');
      if (!b) return;
      if (b.hasAttribute('data-akek-gruppe')) { S.gruppe = b.getAttribute('data-akek-gruppe'); render(); }
      else if (b.hasAttribute('data-akek-minus')) setN(S.n - 1);
      else if (b.hasAttribute('data-akek-plus')) setN(S.n + 1);
      else if (b.hasAttribute('data-zu')) { S.zu = b.getAttribute('data-zu'); render('ziel'); }
      else if (b.hasAttribute('data-bsp')) {
        var x = data.beispiele.filter(function (y) { return y.id === b.getAttribute('data-bsp'); })[0];
        S.von = x.von; S.n = x.n; S.zu = x.zu; S.gruppe = D[x.von].gruppe === 'essen' ? 'essen' : 'technik';
        render('beispiel');
        $('.akek-calc').scrollIntoView({ behavior: ruhig() ? 'auto' : 'smooth', block: 'start' });
        var f = $('input[name="akek-von"]:checked');
        if (f) f.focus({ preventScroll: true });
      } else if (b.hasAttribute('data-akek-link')) track('akek_produkt', { akek_ziel: b.getAttribute('href') });
      else if (b.hasAttribute('data-akan-quelle')) track('akek_quelle_klick', { link_url: b.href });
    });
    root.querySelectorAll('details').forEach(function (dt) {
      dt.addEventListener('toggle', function () { if (dt.open) track('akek_' + dt.getAttribute('data-akek-details')); });
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { track('akek_ansicht'); io.disconnect(); } });
      io.observe($('.akek-calc'));
    }
  }

  try {
    data = JSON.parse($('script[data-akek-daten]').textContent);
    D = index(data.dinge); Z = index(data.ziele);
    leseUrl(); baue(); binde(); render();
    root.dataset.akekReady = '1';
    root.classList.add('is-ready');
  } catch (e) {
    $('[data-akek-live]').textContent = 'Der Rechner konnte nicht starten. Bitte lade die Seite neu.';
    root.classList.add('is-error');
    if (window.console) console.error('[akek]', e);
  }
})();
